import React, { useState, useEffect, useContext, useRef } from 'react';
import { action } from 'mobx';
import { Button, Col, Row } from '@thd-olt-component-react/core-ui';
import { isEmpty } from 'lodash';
import { generateImageSource } from '../../../utils/generateImageSource';
import { getJobTemplate } from '../../../api/SlmService';
import { JobPostingContext } from '../../../contexts/JobPostingContext';
import { CREATE_JOB_POSTING_DEFAULTS } from '../../../utils/constants';

const JobPostingTemplate = ({
  jobDescription,
  setJobDescription,
  educationAndSkills,
  setEducationAndSkills,
  setJobDescriptionDirty
}) => {
  const [jobTemplateAvailable, toggleJobTemplateAvailable] = useState(false);
  const [jobDescriptionTemplate, setJobDescriptionTemplate] = useState('');
  const [previousJobDescriptionTemplate, setPreviousJobDescriptionTemplate] = useState(null);
  const [educationAndSkillsTemplate, setEducationAndSkillsTemplate] = useState('');
  const [previousEducationAndSkillsTemplate, setPreviousEducationAndSkillsTemplate] = useState('');
  const [hideTemplateBanner, setHideTemplateBanner] = useState(false);
  const skipHasTemplateReset = useRef(true);

  const { editedJobPosting, hasTemplate, setHasTemplate } = useContext(JobPostingContext);

  useEffect(() => {
    if (
      !isEmpty(editedJobPosting)
      && editedJobPosting.tradeType !== CREATE_JOB_POSTING_DEFAULTS.TRADE_TYPE_BASIC_HEADER
      && editedJobPosting.yearsOfExperience !== CREATE_JOB_POSTING_DEFAULTS.EXPERIENCE_LEVEL_BASIC_HEADER
    ) {
      setHideTemplateBanner(true);
      getJobTemplate(editedJobPosting.tradeType, editedJobPosting.yearsOfExperience).then(
        action('success', (res) => {
          if (res.data.jobTemplates.length) {
            if (jobDescription !== ' ') {
              setPreviousJobDescriptionTemplate(jobDescriptionTemplate);
            }
            if (educationAndSkills !== '') {
              setPreviousEducationAndSkillsTemplate(educationAndSkillsTemplate);
            }
            setJobDescriptionTemplate(res.data.jobTemplates[0].jobDescription);
            setEducationAndSkillsTemplate(res.data.jobTemplates[0].educationAndSkills);
            toggleJobTemplateAvailable(true);
            if (!skipHasTemplateReset.current) {
              setHasTemplate(false);
            }
            skipHasTemplateReset.current = false;
            window.setTimeout(() => {
              setHideTemplateBanner(false);
            }, 300);
          } else {
            skipHasTemplateReset.current = false;
            clearTemplate();
          }
        }),
        action('error', () => {
          skipHasTemplateReset.current = false;
          clearTemplate();
        })
      );
    }
  }, [editedJobPosting?.tradeType, editedJobPosting?.yearsOfExperience]);

  const clearTemplate = () => {
    toggleJobTemplateAvailable(false);
    setJobDescriptionTemplate(null);
    setEducationAndSkillsTemplate('');
  };

  function removeJobDescriptionTemplate() {
    if (jobDescriptionTemplate === jobDescription) {
      return ' ';
    }
    if (jobDescription.indexOf(`<br>${jobDescriptionTemplate}`) > -1) {
      return jobDescription.replace(`<br>${jobDescriptionTemplate}`, '');
    }
    return jobDescription.replace(`${jobDescriptionTemplate}`, '');

  }

  function removeEducationTemplate() {
    return educationAndSkillsTemplate === educationAndSkills ? '' : educationAndSkills.replace(educationAndSkillsTemplate, '').trim();
  }

  function updateAndUseJobDescriptionTemplate() {
    if (jobDescription.length > 1) {
      if (!!previousJobDescriptionTemplate && jobDescription.indexOf(previousJobDescriptionTemplate) > -1) {
        return `${jobDescription.replace(previousJobDescriptionTemplate, jobDescriptionTemplate)}`;
      }
      return `${jobDescription.replace(/(<br>)+/gm, '')}<br>${jobDescriptionTemplate}`;

    }
    return jobDescriptionTemplate;

  }

  function updateAndUseEducationTemplate() {
    if (educationAndSkills.length > 0) {
      if (previousEducationAndSkillsTemplate && educationAndSkills.indexOf(previousEducationAndSkillsTemplate) > -1) {
        return `${educationAndSkills.replace(previousEducationAndSkillsTemplate, educationAndSkillsTemplate)}`;
      }
      return `${educationAndSkills}${educationAndSkillsTemplate}`;

    }
    return educationAndSkillsTemplate;

  }

  const updateJobData = () => {
    if (hasTemplate) {
      setJobDescriptionDirty(false);
      setHasTemplate(false);
      setJobDescription(removeJobDescriptionTemplate());
      setEducationAndSkills(removeEducationTemplate());
    } else if (!hasTemplate) {
      setJobDescriptionDirty(false);
      setHasTemplate(true);
      setJobDescription(updateAndUseJobDescriptionTemplate());
      setEducationAndSkills(updateAndUseEducationTemplate());
    }
  };

  if (!jobTemplateAvailable
    || hideTemplateBanner
    || (hasTemplate
      && (jobDescription?.indexOf(jobDescriptionTemplate) === -1
        || educationAndSkills?.indexOf(educationAndSkillsTemplate) === -1)
    )) {
    return <></>;
  }

  return (
    <div style={{ padding: '10px', paddingTop: '5px' }}>
      <Row className="job-posting-template">
        <Col xs="8">
          <div className="job-posting-template__label">
            <p>Job Template Available</p>
          </div>
          <div className="job-posting-template__text">
            <p>
              Use our pre-written templates to save time and effort. <br />
              Click “Use Template”, then edit the content to meet your unique job needs.
            </p>
          </div>
        </Col>
        <Col xs="4">
          <div className="job-posting-template__button">
            <Button onClick={updateJobData}>
              {!hasTemplate ? 'Use Template' : 'Remove Template'}
              <img
                className="job-posting-template__button-plus-icon"
                src={generateImageSource(`/images/v1/path-to-pro/${(hasTemplate) ? 'minus_icon.svg' : 'plus_icon.svg'}`)}
              />
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default JobPostingTemplate;
